export const smallScreenMaxWidth = 720;
export const mediumScreenMaxWidth = 1030;
export const largeScreenMinWidth = 1031;

export const smallMediaQuery = `(max-width: ${smallScreenMaxWidth}px)`;
export const mediumMediaQuery = `(min-width: ${smallScreenMaxWidth + 1}px and max-width: ${mediumScreenMaxWidth}px)`;
export const largeMediaQuery = `(min-width: ${largeScreenMinWidth}px)`;
